/**
 * Official W!ntAi social profiles (digital trail).
 * Create these pages on each platform if they do not exist yet, then adjust URLs to match your handles.
 */
export const WINTAI_SOCIAL = {
  x: 'https://x.com/wintaibot',
  facebook: 'https://www.facebook.com/wintaibot',
  linkedin: 'https://www.linkedin.com/company/wintaibot',
};
